import React from 'react';
import { Columns } from '@components/Columns';
import {
  StyledSectionWrapper,
  StyledBox,
  BlogCenterTextPairing,
  StyledColumnDesktop,
  StyledButtonBox,
  StyledButton,
  ColumnInfo,
  StyledBackgroundCloudImage,
} from './ExclusiveGroupRatesSection.styles';

import { CloudImage } from '@components/CloudImage';
import { useTranslation } from 'react-i18next';

export const ExclusiveGroupRatesSection: React.FC = () => {
  const { t } = useTranslation('hotelRoomBlocks');
  const exclusiveGroupRatesSectionData = t('exclusiveGroupRatesSection');

  return (
    <StyledSectionWrapper as="section" id="Exclusive_Group_Rates" marginTop={[0, 12]} marginBottom={11}>
      <StyledBackgroundCloudImage src="" srcMobile="hotel-room-blocks/ExclusiveGroupRates/Save-Mobile-L.png">
        <Columns verticalAlign="center" marginTop={[8, 0]}>
          <ColumnInfo width={6} mobile={12}>
            <StyledBox>
              <BlogCenterTextPairing
                alignment="left"
                eyebrow={exclusiveGroupRatesSectionData.eyebrow}
                eyebrowColor="humanaDark4"
                eyebrowVariant="sectionEyeBrow20"
                eyebrowTagName="h2"
                title={exclusiveGroupRatesSectionData.title}
                titleVariant="hed56"
                titleColor="neutra6"
                titleTagName="h2"
                body={exclusiveGroupRatesSectionData.description}
                bodyVariant="dek24"
                bodyColor="neutra5"
                bodyTagName="p"
              />
              <StyledButtonBox marginTop={[8, 8]} marginBottom={[10, 0]}>
                <StyledButton id={`exclusiveGroupRatesSectionGetStartedBtn`} page={'hotel-room-blocks'} variant="primary">
                  {exclusiveGroupRatesSectionData.buttonStarted}
                </StyledButton>
              </StyledButtonBox>
            </StyledBox>
          </ColumnInfo>
          <StyledColumnDesktop offset={1} width={6} mobile={12}>
            <CloudImage src={exclusiveGroupRatesSectionData.image} width={'100%'} />
          </StyledColumnDesktop>
        </Columns>
      </StyledBackgroundCloudImage>
    </StyledSectionWrapper>
  );
};
